var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.11 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.81,17.46l-3.8-3.81v2.51h-6.31l-4.83-4.83-2.83,2.83,6,6h0s0,0,0,0h7.96v2.51s3.8-3.8,3.8-3.8c.29-.29.37-.72.22-1.08-.05-.12-.12-.23-.22-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.06,2.51h0s0,0,0,0H1c-.55,0-1,.45-1,1v2c0,.55.45,1,1,1h5.4l4.83,4.83,2.83-2.83-6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4,16.17H1c-.55,0-1,.45-1,1v2c0,.55.45,1,1,1h7.05s0,0,0,0l6-6-2.83-2.83-4.83,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.71,6.51h6.3v2.51s3.8-3.8,3.8-3.8c.29-.29.37-.72.22-1.08-.05-.12-4.02-4.14-4.02-4.14v2.51h-7.95s-.01,0-.01,0l-6,6,2.83,2.83,4.83-4.83Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.bf34665f67ee8b1591d6f539657fcb2d.svg";
export { ForwardRef as ReactComponent };